import React, { forwardRef, useImperativeHandle, Ref } from 'react';
import { DataTableProviderProps } from 'src/components/DataTable/types/DataTable';
import { DataTableRef } from 'src/components/DataTable/types/DataTableRef';
import { useDataTable } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTable';
import { DataTableContext } from './DataTableContext';

function DataTableProviderInner<TData, TFilters>(
  { adapter, initialState, children }: DataTableProviderProps<TData, TFilters>,
  ref: Ref<DataTableRef<TFilters>>
): JSX.Element {
  const contextValue = useDataTable(adapter, initialState);

  useImperativeHandle(
    ref,
    () => ({
      setQuery: contextValue.setQuery,
      setPage: contextValue.setPage,
      reset: contextValue.reset,
      getState: () => contextValue.tableState,
    }),
    [
      contextValue.setQuery,
      contextValue.setPage,
      contextValue.reset,
      contextValue.tableState,
    ]
  );

  return (
    <DataTableContext.Provider value={contextValue}>
      {children}
    </DataTableContext.Provider>
  );
}

export const DataTableProvider = forwardRef(DataTableProviderInner) as <
  TData,
  TFilters
>(
  props: DataTableProviderProps<TData, TFilters> & {
    ref?: Ref<DataTableRef<TFilters>>;
  }
) => JSX.Element;
